import { render, staticRenderFns } from "./GiftLabel.vue?vue&type=template&id=043aeb07&"
import script from "./GiftLabel.vue?vue&type=script&lang=js&"
export * from "./GiftLabel.vue?vue&type=script&lang=js&"
import style0 from "./GiftLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports